import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviFacturesService, { SuiviFinancierParams } from '../../../services/SuiviFacturesService';
import { SUIVI_FINANCIER } from './mutation-types';
import { SuiviFinancier, SuiviFinancierActionTypes } from './action-types';
import { state, SuiviFinancierState } from './state';

export const actions: ActionTree<SuiviFinancierState, RootState> = {
    async [SuiviFinancier.GET_SUIVI_FINANCIER](
        { commit }: SuiviFinancierActionTypes,
        payload: SuiviFinancierParams
    ) {
        commit(SUIVI_FINANCIER.SET_PAGE, payload.page);
        commit(SUIVI_FINANCIER.SET_ERROR_SUIVI_FINANCIER, undefined);
        commit(SUIVI_FINANCIER.SET_IS_LOADING_SUIVI_FINANCIER, true);
        payload.chantierIds = state.siteList;
        try {
            const response = await SuiviFacturesService.getSuiviFactures(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(SUIVI_FINANCIER.SET_ITEMS_SUIVI_FINANCIER, response.data);
                    commit(SUIVI_FINANCIER.SET_SCROLL, 0);
                    commit(SUIVI_FINANCIER.SET_NB_PAGES, parseInt(response.headers.pages) || 0);
                } else {
                    commit(SUIVI_FINANCIER.ADD_ITEMS, response.data);
                }
            } else {
                commit(SUIVI_FINANCIER.SET_IS_LOADING_SUIVI_FINANCIER, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FINANCIER.SET_IS_LOADING_SUIVI_FINANCIER, false);
        } catch (error) {
            commit(SUIVI_FINANCIER.SET_IS_LOADING_SUIVI_FINANCIER, false);
            commit(SUIVI_FINANCIER.SET_ERROR_SUIVI_FINANCIER, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviFinancier.GET_SUIVI_FINANCIER_XLS](
        { commit }: SuiviFinancierActionTypes,
    ) {
        commit(SUIVI_FINANCIER.SET_XLS_IS_LOADING, true);
        try {
            const response = await SuiviFacturesService.getSuiviFacturesXls();
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Export_suivi_financier.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FINANCIER.SET_XLS_IS_LOADING, false);
        } catch (error) {
            commit(SUIVI_FINANCIER.SET_XLS_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviFinancier.GET_FACTURE_PDF](
        { commit }: SuiviFinancierActionTypes,
        payload: {interventionId: number, chantierId: number}
    ) {
        try {
            commit(SUIVI_FINANCIER.SET_PDF_IS_LOADING, true);
            const response = await SuiviFacturesService.getFacturePdfByInterventionId(payload.interventionId, payload.chantierId);
            if (response.status === 200 && response.data !== undefined) {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = `Facture_Intervention-n°${payload.interventionId}.pdf`;
                link.click();
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FINANCIER.SET_PDF_IS_LOADING, false);
        } catch (error) {
            commit(SUIVI_FINANCIER.SET_PDF_IS_LOADING, false);
            commit(SUIVI_FINANCIER.SET_ERROR_SUIVI_FINANCIER, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
